import React from 'react';
import { Platform, View, StyleSheet } from 'react-native';

import colors from 'shared/modules/common/constants/colors';

type CardProps = {
  children: JSX.Element | Array<JSX.Element | null> | null;
  style?: ViewStyleProp;
};

export default function Card({ children, style, ...other }: CardProps) {
  return (
    <View style={[styles.container, style]} {...other}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: 72,
    justifyContent: 'center',
    backgroundColor: colors.white,
    borderRadius: 8,
    ...Platform.select({
      android: {
        elevation: 2,
      },
      ios: {
        shadowColor: 'rgba(0, 0, 0, 0.08)',
        shadowOpacity: 1,
        shadowRadius: 8,
        shadowOffset: {
          width: 0,
          height: 2,
        },
      },
    }),
  },
});
